import { News } from '../../components/News/NewsList/index.jsx'

export const AllNews = () => {
    return <News title="Todas las noticias" full={true} />
}
